import { graphql } from '@teachino/shared-infrastructure';
import { featureFragment } from './feature.fragment';

// Fields needed for trial/grace/paywall checks. Applies to all License types, not only personal.
export const personalLicenseFragment = graphql(
  `
    fragment PersonalLicense on License {
      id
      holderType
      cycleStartAt
      cycleRenewalAt
      expiresAt
      features {
        ...Feature
      }
      plan {
        id
        key
        type
      }
    }
  `,
  [featureFragment],
);
